/**
 * @module settingGroups/NullHanding
 * @description 空值处理配置组 — 折线图 / 事件折线图
 */

import React from 'react';
import { useIntl } from 'umi';
import ConfigCollapseCard from '@/pages/datalab/components/ConfigCollapseCard';
import NullUISelector from './NullUISelector';
import './index.scss';

const NullHanding: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <ConfigCollapseCard
      title={formatMessage({ id: 'dbl_chart_null_handing' })}
      className="dbl-null-handing"
      defaultActiveIds={[]}
    >
      <NullUISelector />
    </ConfigCollapseCard>
  );
};

export default React.memo(NullHanding);
